import { render, staticRenderFns } from "./StockConsumed.vue?vue&type=template&id=381e2572&"
import script from "./StockConsumed.vue?vue&type=script&lang=js&"
export * from "./StockConsumed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports